import React from 'react';
import { Box, Flex, Text, Divider, Tooltip, Badge, Image, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel } from '@chakra-ui/react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import useStore from '../../../store';
import DownloadAndViewButton from '../../../components/Files/DownloadAndViewButton';
const leftLabelWidth = '120px';

export default function NewDetail(props) {
	const { t } = useTranslation();
	const { currentLang } = useStore((state) => state.currentLang);
	const { complaint, row, newGetStatus, loadData } = props;

	function getStatus({ settled, settledDate }, adminComplaintStatus) {
		if (settled === true) {
			return (
				<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
					<Badge colorScheme="green">{t('Settled')}</Badge>
				</Tooltip>
			);
		} else {
			switch (adminComplaintStatus) {
				case 'IN_PROGRESS':
					return <Badge colorScheme="red">{t('In progress')}</Badge>;
				case 'WAITING_FOR_COMPANY_REPLY':
					return <Badge colorScheme="yellow">{t('Waiting for company reply')}</Badge>;
				case 'RECIEVED_COMPANY_REPLY':
					return <Badge colorScheme="teal">{t('Received company reply')}</Badge>;
				case 'PROVIDED_REPLY_LETTER_TO_APPLICANT':
					return <Badge colorScheme="purple">{t('Provided reply letter to applicant')}</Badge>;
				case 'APPLICANT_MADE_DECISION':
					return <Badge colorScheme="blue">{t('Applicant made decision')}</Badge>;
				case 'SETTLED':
					return (
						<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
							<Badge colorScheme="green">{t('Settled')}</Badge>
						</Tooltip>
					);
				case 'WITHDRAWN':
					return <Badge colorScheme="gray">{t('Withdrawn')}</Badge>;
				default:
					return <Badge colorScheme="gray">{t('old complaint')}</Badge>;
			}
		}
	}

	function complaintOnCompany() {
		return (
			<Flex style={{ pageBreakInside: 'avoid' }} p="2" _hover={{ bg: 'gray.200' }} align={'center'}>
				<Text mr="2" fontWeight="500" w="200px" minW="200px">
					{t('Complaint on Company')}:
				</Text>
				<Flex direction="column" justifyContent="center" alignItems="center">
					<Flex justifyContent="center">
						<Image
							// maxW="70px"
							maxH="40px"
							h="auto"
							w="auto"
							src={c.baseFilePath + complaint?.complaintOnCompany?.logo}
							alt={`${complaint?.complaintOnCompany?.name} - ${complaint?.complaintOnCompany?.nameKhmer}`}
							objectFit="contain"
							fallbackSrc="/files/images/no-logo.png"
						/>
					</Flex>
					<Text textAlign="center">{currentLang === 'en' ? complaint?.complaintOnCompany?.name : complaint?.complaintOnCompany?.nameKhmer}</Text>
				</Flex>
			</Flex>
		);
	}

	function FileViewer({ label = null, platform = null, file = [], files = [], labelWeight = '500', p = 1, pl = 2 }) {
		return (
			<Flex style={{ pageBreakInside: 'avoid' }} p="2" _hover={{ bg: 'gray.200' }} align={'center'}>
				<Text mr="2" fontWeight="500" w="200px" minW="200px">
					{t(label)}:
				</Text>

				{platform === 'mobile' && (
					<Box ml={2} width="200px">
						{files?.length > 0 ? (
							<>
								<Accordion allowToggle allowMultiple bg="gray.100" borderRadius={2}>
									<AccordionItem border="none">
										<AccordionButton backgroundColor="gray.100" _hover={{ backgroundColor: 'gray.100' }}>
											<Box as="span" flex="1" textAlign="left">
												<Flex justifyContent="flex-start" alignItems="center">
													<Text fontWeight="normal" fontSize="sm">
														{t('Files')}
													</Text>
													&nbsp;
													<Text fontWeight="semibold" fontSize="md">{`(${files?.length})`}</Text>
												</Flex>
											</Box>
											<AccordionIcon />
										</AccordionButton>
										<AccordionPanel>
											{files?.map((file, i) => (
												<Box key={i} mb={i === files?.length - 1 ? 0 : 2}>
													<DownloadAndViewButton url={file?.url} size={file?.size} marginLeft={0} />
												</Box>
											))}
										</AccordionPanel>
									</AccordionItem>
								</Accordion>
							</>
						) : (
							<>
								<Text>N/A</Text>
							</>
						)}
					</Box>
				)}
				{platform === 'web' && (
					<Box ml={2} width="200px">
						{file?.length > 0 ? (
							<>
								<Accordion allowToggle allowMultiple bg="gray.100" borderRadius={2}>
									<AccordionItem border="none">
										<AccordionButton backgroundColor="gray.100" _hover={{ backgroundColor: 'gray.100' }}>
											<Box as="span" flex="1" textAlign="left">
												<Flex justifyContent="flex-start" alignItems="center">
													<Text fontWeight="normal" fontSize="sm">
														{t('Files')}
													</Text>
													&nbsp;
													<Text fontWeight="semibold" fontSize="md">{`(${file?.length})`}</Text>
												</Flex>
											</Box>
											<AccordionIcon />
										</AccordionButton>
										<AccordionPanel>
											{file?.map((file, i) => (
												<Box key={i} mb={i === file?.length - 1 ? 0 : 2}>
													<DownloadAndViewButton url={file?.url} size={file?.size} marginLeft={0} />
												</Box>
											))}
										</AccordionPanel>
									</AccordionItem>
								</Accordion>
							</>
						) : (
							<>
								<Text>N/A</Text>
							</>
						)}
					</Box>
				)}
			</Flex>
		);
	}

	return (
		<>
			{row('Number', complaint?.no)}
			{/* {complaint?.complaintType === 'COMPLAINT' &&
				row(
					'Complaint Category',
					complaint?.complaintOnInsuranceCategories === 'COMPLAINT_OF_DISSATISFACTION_ON_INSURANCE'
						? 'Complaint of dissatifaction on insurance'
						: 'Complaint on dispute insurance'
				)} */}
			{row('Created At', moment(complaint?.createdAt).format('LLL'))}

			<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
				<Text mr="2" fontWeight="500" w="200px">
					{t('Status')}:
				</Text>
				<Box>{getStatus({ settled: complaint?.settled, settledDate: complaint?.settledDate }, complaint?.adminComplaintStatus)}</Box>
			</Flex>
			{complaint?.settled && <>{row('Settled at', moment(complaint?.settledDate).format('LLL'))}</>}

			<Divider h="1px" mt="8" mb="8" />

			{/* Detail section */}
			<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
				{t('Detail')}
			</Text>
			{complaintOnCompany()}

			{row('Subject', complaint?.subject)}
			{row('Cause', complaint?.cause)}
			{row('Demand', complaint?.demand)}
			{<FileViewer label="Proof" platform={complaint?.platform} file={complaint?.proofFile} files={complaint?.proofFileMobile} />}
			<FileViewer label="Other file" platform={complaint?.platform} file={complaint?.otherFile} files={complaint?.otherFileMobile} />

			{/* Plaintiff Information Section */}
			<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
				{complaint?.plaintiff === 'REAL_PERSON' ? t('Natural person') : t('Legal entity')}
			</Text>
			{complaint?.plaintiff === 'REAL_PERSON' && row('Name', complaint?.name)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Gender', t(complaint?.gender))}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Date of birth', complaint?.dob ? moment(complaint?.dob).format('l') : '')}
			{complaint?.plaintiff === 'REAL_PERSON' && (
				<FileViewer label="Plaitiff Id Card" platform={complaint?.platform} file={complaint?.plaintiffIdCard} files={complaint?.plaintiffIdCard} />
			)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('State', complaint?.state)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('rDistrict', complaint?.district)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('rCommune', complaint?.commune)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Village', complaint?.village)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Street Number', complaint?.streetNumber)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('House Number', complaint?.houseNumber)}
			{complaint?.plaintiff === 'LEGAL_ENTITY' && row('Company Name', complaint?.companyName)}
			{complaint?.plaintiff === 'LEGAL_ENTITY' && (
				<FileViewer
					label="Business license"
					platform={complaint?.platform}
					file={complaint?.copyOfBusinessLicense}
					files={complaint?.copyOfBusinessLicenseMobile}
				/>
			)}
			{complaint?.plaintiff === 'LEGAL_ENTITY' && row('Business objects', complaint?.companyObjects)}
			{complaint?.plaintiff === 'LEGAL_ENTITY' && row('Address', complaint?.address)}
			{row('Contact Phone number', complaint?.phoneNumber)}
			{row('Email', complaint?.email)}
			{row('Social media URL', complaint?.socialMediaUrl)}

			{/* Representative Information Section if exists */}
			{complaint?.representative === 'yes' ? (
				<>
					<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
						{t('representative information')}
					</Text>
					{row('Name', complaint?.plaintiffOrRepresentativeName)}
					{row('Contact Phone number', complaint?.plaintiffOrRepresentativePhoneNumber)}
					{
						<FileViewer
							label="Signature or fingerprint"
							platform={complaint?.platform}
							file={complaint?.signatureOrFingerPrintOfPlaintiffOrRepresentative}
							files={complaint?.signatureOrFingerPrintOfPlaintiffOrRepresentativeMobile}
						/>
					}

					<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
						{t('Files')}
					</Text>

					<>{<FileViewer label="ID Card" platform={complaint?.platform} file={complaint?.copyOfIdCard} files={complaint?.copyOfIdCardMobile} />}</>
				</>
			) : (
				<>
					<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
						{t('no representative')}
					</Text>
				</>
			)}
			<Divider h="1px" mt="8" mb="8" />
		</>
	);
}
